import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogFooter,
    DialogClose,
} from "@/components/ui/dialog";
import { Label } from "@/components/atoms/texts/label";
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { Button } from "@/components/molecules/buttons/button";
import { useEffect, useRef, useState } from "react";
import { useToast } from "@/components/organisms/feedback/use-toast";
import { ToastAction } from "@/components/organisms/feedback/toast";
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { useUpdateProfile } from "@/services/consultant-services/mutation/useUpdateProfile";
import { getCountryCode, getCountryData, getCountryDataList, getEmojiFlag } from 'countries-list'
import { continents, countries, languages } from 'countries-list'
import { Select, SelectContent, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import { isEmail, isPhoneNumber, isNotEmpty, isIban, isBic, isZipCode, isAddressLine } from "@/utils/validationInput"
import useUpdateUser from "@/services/mutation/admin-mutations/useUpdateUserl";
import { useUpdateConsultantProfile } from "@/services/mutation/admin-mutations/useUpdateConsultantProfile";
import { getCountryList } from "@/utils/getCountriesLanguagesAndCode";
import { useCallback } from "react";
import { useConsultantContext } from "@/context/ConsultantContext";
import { DatePicker } from "@/components/molecules/inputs/DatePicker";
import { useParams } from "react-router-dom";
import { da } from "date-fns/locale";
import { useUpdateConsultantInvoiceDefaults } from "@/services/admin-services/mutations/useUpdateConsultantInvoiceDefaultsRequestDto";
import { Switch } from "@/components/ui/switch";
import PrintErrorMessage from "../feedback/PrintErrorMessage";

export default function EditInformationData({ inputValue, setInputValue, secondaryInputValue, setSecondaryInputValue, title, actualLabel, selectLabel, data, secondaryData, type, refetchCurrentUser, consultantUuid, setInformationData, typeForInput, unit = "", component, exceptionnalData, allProfiles, profilesLoading, profilesError }) {
    const [open, setOpen] = useState();
    const skipUnsavedWarningOnNextCloseRef = useRef(false);
    const autoCommissionAtOpenRef = useRef(undefined);

    const { toast } = useToast();
    const { updateIban, updateBicCode, updateAddress, updatePersonalEmail, updatePhoneNumber, updateDailyRateConsultantEur, updateCommissionAmount } = useUpdateProfile();
    const { updateIban: updateIbanForAdmin, updateBic: updateBicForAdmin, updatePhoneNumber: updatePhoneNumberForAdmin, updatePersonalEmail: updatePersonalEmailForAdmin, updateAddress: updateAddressForAdmin, updateFiduciaryId, updateLeaveDate,
        // updateDailyRateConsultantEur, updateCommissionAmount // <-- Ajout des mutations
        loadingRetribution, errorRetribution,
        loadingLanguage, errorLanguage,
        loadingIban, errorIban,
        loadingBic, errorBic,
        loadingPhoneNumber, errorPhoneNumber,
        loadingPersonalEmail, errorPersonalEmail,
        loadingAddress, errorAddress,
        loadingFiduciaryId, errorFiduciaryId,
        loadingLeaveDate, errorLeaveDate,
    } = useUpdateUser();
    const { activeUser, setActiveUser } = useConsultantContext() ? useConsultantContext() : { activeUser: {}, setActiveUser: () => { } };
    const { updateDailyRate, updateCommission } = useUpdateConsultantInvoiceDefaults();
    const { setConsultantProfile, loading: loadingProfile, error: errorProfile } = useUpdateConsultantProfile();

    const [autoCommission, setAutoCommission] = useState();

    useEffect(() => {
        // Met à jour le toggle si la donnée change
        if (type === "commissionAmount" || type === "commissionAmounts") {
            setAutoCommission(exceptionnalData === false || !data); // exceptionnalData est utilisé pour passer la valeur de manualCommission
        }
        console.log('test = ', exceptionnalData, exceptionnalData === false, !data, data)
    }, [data, type, exceptionnalData]);

    useEffect(() => {
        if (open && type === "commissionAmounts") {
            setInputValue(data ?? "");
            setSecondaryInputValue && setSecondaryInputValue(secondaryData ?? "");
        }
    }, [open, type, data, secondaryData, setInputValue, setSecondaryInputValue]);

    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [isWrongFormat, setIsWrongFormat] = useState(false);

    const [t] = useTranslation("global")
    // const countriesWithPriority = useCallback(getCountryList(),[]);
    const [countriesWithPriority, setcountriesWithPriority] = useState();

    useEffect(() => {
        let countries = getCountryList();
        setcountriesWithPriority(countries);
    }, []);

    const validateInput = (optionalValue) => {
        let isValid = true;
        if (type === 'iban') {
            isValid = isIban(optionalValue || inputValue);
        } else if (type === 'bicCode') {
            isValid = isBic(optionalValue || inputValue);
        } else if (type === 'phoneNumber') {
            isValid = isPhoneNumber(optionalValue || inputValue);
        } else if (type === 'personalEmail') {
            isValid = isEmail(optionalValue || inputValue);
        } else if (type === 'fiduciaryId') {
            isValid = Number.isInteger(Number(optionalValue || inputValue));
        }
        else if (type === 'leaveDate') {
            isValid = !isNaN(Date.parse(optionalValue || inputValue));
            console.log("validateInput leaveDate", inputValue, isValid, type)
        }
        else if (type === 'address') {
            isValid = isAddressLine(optionalValue || addressLine1) && isZipCode(optionalValue || zipCode) && isNotEmpty(optionalValue || city) && isNotEmpty(optionalValue || country);
        }
        else if (type === 'dailyRateConsultantEur') {
            isValid = !isNaN(Number(optionalValue || inputValue)) && (optionalValue || inputValue) !== "";
        }
        else if (type === 'commissionAmount') {
            if (!autoCommission) {
                isValid = !isNaN(Number(optionalValue || inputValue)) && (optionalValue || inputValue) !== "";
            }
        }
        else if (type === 'commissionAmounts') {
            if (!autoCommission) {
                const monthlyValid = !isNaN(Number(inputValue)) && inputValue !== "";
                const dailyValid = !isNaN(Number(secondaryInputValue)) && secondaryInputValue !== "";
                isValid = monthlyValid && dailyValid;
            }
            // mode auto : toujours valide, aucun champ requis
        }
        else if (type === 'dailyCommissionAmount') {
            isValid = !isNaN(Number(optionalValue || inputValue)) && (optionalValue || inputValue) !== "";
        }
        else if (type === 'consultantProfile') {
            isValid = isNotEmpty(optionalValue || inputValue);
        }
        console.log("validateInput", inputValue, isValid, type)
        setIsWrongFormat(!isValid);
        return isValid;
    };

    const handleClose = (open_, dataSaved = false, inputValue) => {
        const safeInputValue = typeof inputValue === "string"
            ? inputValue
            : (inputValue === null || inputValue === undefined ? "" : String(inputValue));

        if (open_ === false && dataSaved) {
            skipUnsavedWarningOnNextCloseRef.current = true;
        }

        setOpen(open_);
        if (open_ === false) {
            if (!dataSaved) {
                safeInputValue && toast({
                    variant: "warning",
                    title: "error.editWithoutSave",
                    description: safeInputValue,
                    duration: 2500,
                    action: (
                        <ToastAction
                            altText={safeInputValue}
                            onClick={async () => {
                                await navigator.clipboard.writeText(safeInputValue);
                            }}
                            className="border-0 py-thirdDegree"
                        >
                            <ContentCopyRoundedIcon />
                        </ToastAction>
                    ),
                });

            } else {
                safeInputValue && toast({
                    variant: "success",
                    title: "success.changesSaved",
                    description: safeInputValue,
                    duration: 4000,
                    action: (
                        <ToastAction
                            altText={safeInputValue}
                            onClick={async () => {
                                await navigator.clipboard.writeText(safeInputValue);
                            }}
                            className="border-0 py-thirdDegree"
                        >
                            <ContentCopyRoundedIcon />
                        </ToastAction>
                    ),
                });
            }
        }
        resetForm();
    }

    const handleDialogOpenChange = (nextOpen) => {
        setOpen(nextOpen);
        if (nextOpen) {
            autoCommissionAtOpenRef.current = autoCommission;
            return;
        }

        if (!nextOpen) {
            if (skipUnsavedWarningOnNextCloseRef.current) {
                skipUnsavedWarningOnNextCloseRef.current = false;
            } else {
                const hasTextValue = (value) => {
                    if (value === null || value === undefined) return false;
                    return String(value).trim() !== "";
                };

                const isCommissionType = type === "commissionAmount" || type === "commissionAmounts";
                const hasToggleChanged = isCommissionType
                    && autoCommissionAtOpenRef.current !== undefined
                    && autoCommissionAtOpenRef.current !== autoCommission;

                const hasUnsavedValues = hasTextValue(inputValue) || hasTextValue(secondaryInputValue) || hasToggleChanged;

                if (hasUnsavedValues) {
                    toast({
                        variant: "warning",
                        title: "error.editWithoutSave",
                        duration: 2500,
                    });
                }
            }

            resetForm();
            setInputValue("");
            setSecondaryInputValue && setSecondaryInputValue("");
        }
    }

    const handleSave = async () => {
        console.log("handleSave type", type, "consultantUuid", consultantUuid);

        if (validateInput() == false) return null
        (!inputValue && type != "address" && type !== "commissionAmounts" && !(type === "commissionAmount" && autoCommission)) && toast({
            variant: "error",
            title: "error.cantBeNull",
            duration: 8000,
        });

        try {
            if (consultantUuid) {
                // if consultantUuid > is admin use case
                if (type === 'iban') {
                    await updateIbanForAdmin({ variables: { uuid: consultantUuid, iban: inputValue } });

                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        iban: inputValue
                    }));

                    handleClose(false, true, inputValue);
                } else if (type === 'leaveDate') {
                    await updateLeaveDate({ variables: { uuid: consultantUuid, leaveDate: inputValue } });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        leaveDate: inputValue
                    }));
                    // Mise à jour du context
                    setActiveUser({
                        ...activeUser,
                        leaveDate: inputValue
                    });
                    handleClose(false, true, inputValue);
                } else if (type === 'bicCode') {
                    await updateBicForAdmin({ variables: { uuid: consultantUuid, bicCode: inputValue } });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        bicCode: inputValue
                    }));
                    handleClose(false, true, inputValue);
                } else if (type === 'phoneNumber') {
                    await updatePhoneNumberForAdmin({ variables: { uuid: consultantUuid, phoneNumber: inputValue } });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        phoneNumber: inputValue
                    }));
                    handleClose(false, true, inputValue);
                } else if (type === 'personalEmail') {
                    await updatePersonalEmailForAdmin({ variables: { uuid: consultantUuid, personalEmail: inputValue } });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        personalEmail: inputValue
                    }));
                    handleClose(false, true, inputValue);
                } else if (type === 'fiduciaryId') {
                    await updateFiduciaryId({ variables: { uuid: consultantUuid, fiduciaryId: inputValue } });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        fiduciaryId: inputValue
                    }));
                    handleClose(false, true, inputValue);
                } else if (type === 'address') {
                    // const countryCode = getCountryCode(country);
                    const countryCode = country;
                    const address = `${addressLine1}, ${addressLine2}, ${zipCode}, ${city}, ${countryCode}`;
                    await updateAddressForAdmin({ variables: { uuid: consultantUuid, addressLine1, addressLine2, zipCode, city, countryCode } });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        addressLine1: addressLine1,
                        addressLine2: addressLine2,
                        zipCode: zipCode,
                        city: city,
                        countryCode: countryCode
                    }));
                    handleClose(false, true, address);
                } else if (type === 'dailyRateConsultantEur') {
                    await updateDailyRate({
                        variables: {
                            updatedInvoiceDefaults: {
                                consultantUuid,
                                dailyRateConsultantEur: Number(inputValue),
                                // commissionEur: data?.commissionEur ?? 0,
                                // manualCommission: data?.manualCommission ?? false
                            }
                        }
                    });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        consultantInvoiceDefaults: {
                            ...prevData.consultantInvoiceDefaults,
                            dailyRateConsultantEur: inputValue
                        }
                    }));
                    handleClose(false, true, inputValue);
                } else if (type === 'commissionAmounts') {
                    const updatedInvoiceDefaults = {
                        consultantUuid,
                        manualCommission: !autoCommission,
                    };

                    if (!autoCommission) {
                        updatedInvoiceDefaults.monthlyCommissionEur = Number(inputValue);
                        updatedInvoiceDefaults.dailyCommissionEur = Number(secondaryInputValue);
                    }

                    await updateCommission({
                        variables: {
                            updatedInvoiceDefaults
                        }
                    });

                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        consultantInvoiceDefaults: {
                            ...prevData.consultantInvoiceDefaults,
                            monthlyCommissionEur: autoCommission ? undefined : inputValue,
                            dailyCommissionEur: autoCommission ? undefined : secondaryInputValue,
                            manualCommission: !autoCommission
                        }
                    }));
                    handleClose(false, true, autoCommission ? "Auto" : `${inputValue} / ${secondaryInputValue}`);
                } else if (type === 'commissionAmount') {
                    if (autoCommission) {
                        // Commission automatique activée
                        await updateCommission({
                            variables: {
                                updatedInvoiceDefaults: {
                                    consultantUuid,
                                    manualCommission: false
                                }
                            }
                        });
                        setInformationData && setInformationData((prevData) => ({
                            ...prevData,
                            consultantInvoiceDefaults: {
                                ...prevData.consultantInvoiceDefaults,
                                monthlyCommissionEur: undefined,
                                manualCommission: false
                            }
                        }));
                        handleClose(false, true, "");
                    } else {
                        // Commission manuelle activée (seulement monthlyCommission)
                        await updateCommission({
                            variables: {
                                updatedInvoiceDefaults: {
                                    consultantUuid,
                                    monthlyCommissionEur: Number(inputValue),
                                    manualCommission: true
                                }
                            }
                        });
                        setInformationData && setInformationData((prevData) => ({
                            ...prevData,
                            consultantInvoiceDefaults: {
                                ...prevData.consultantInvoiceDefaults,
                                monthlyCommissionEur: inputValue,
                                manualCommission: true
                            }
                        }));
                        handleClose(false, true, inputValue);
                    }
                } else if (type === 'dailyCommissionAmount') {
                    await updateCommission({
                        variables: {
                            updatedInvoiceDefaults: {
                                consultantUuid,
                                dailyCommissionEur: Number(inputValue)
                            }
                        }
                    });
                    setInformationData && setInformationData((prevData) => ({
                        ...prevData,
                        consultantInvoiceDefaults: {
                            ...prevData.consultantInvoiceDefaults,
                            dailyCommissionEur: inputValue
                        }
                    }));
                    handleClose(false, true, inputValue);
                } else if (type === 'consultantProfile') {
                    // Gestion du changement de profil consultant
                    const { data: profileData, error: profileError } = await setConsultantProfile(consultantUuid, inputValue);
                    if (profileError) {
                        toast({
                            variant: "error",
                            title: "error.requestFailed",
                            duration: 8000,
                            message: profileError
                        })
                        console.error("Error updating consultant profile:", profileError);
                    } else {
                        // Trouver le nom du profil dans allProfiles à partir de l'UUID
                        const selectedProfileName = allProfiles?.find(profile => profile.uuid === inputValue)?.name || 
                                                   profileData.consultantProfile?.name || 
                                                   inputValue;
                        console.debug("Consultant profile updated successfully:", profileData, selectedProfileName, inputValue, data);
                        
                        // Construire l'objet profil complet pour l'affichage
                        const updatedProfile = allProfiles?.find(profile => profile.uuid === inputValue) || 
                                             profileData.consultantProfile || 
                                             { uuid: inputValue, name: selectedProfileName };
                        
                        setInformationData && setInformationData((prevData) => ({
                            ...prevData,
                            consultantProfile: updatedProfile,
                            // Réinitialiser les commissions pour afficher "non renseigné" jusqu'au refresh
                            consultantInvoiceDefaults: {
                                ...prevData.consultantInvoiceDefaults,
                                // monthlyCommissionEur: undefined,
                                // dailyCommissionEur: undefined
                            }
                        }));
                        handleClose(false, true, selectedProfileName);
                    }
                }

            } else {
                if (type === 'iban') {
                    await updateIban({ variables: { iban: inputValue } });
                    handleClose(false, true, inputValue);
                } else if (type === 'bicCode') {
                    await updateBicCode({ variables: { bicCode: inputValue } });
                    handleClose(false, true, inputValue);
                } else if (type === 'phoneNumber') {
                    await updatePhoneNumber({ variables: { phoneNumber: inputValue } });
                    handleClose(false, true, inputValue);
                } else if (type === 'personalEmail') {
                    await updatePersonalEmail({ variables: { personalEmail: inputValue } });
                    handleClose(false, true, inputValue);
                } else if (type === 'fiduciaryId') {
                    // do nothing because this case isn't supposed to happen
                    handleClose(false, false, inputValue);
                } else if (type === 'address') {

                    //                     const countryCode = getCountryCode(country);
                    // console.log("countryCode 2", countryCode);
                    const countryCode = country;

                    const address = `${addressLine1}, ${addressLine2}, ${zipCode}, ${city}, ${countryCode}`;
                    await updateAddress({ variables: { addressLine1, addressLine2, zipCode, city, countryCode } });
                    handleClose(false, true, address);
                } else {
                    // do nothing
                    console.log("Edit information data : No action for type", type);
                    handleClose(false, false, inputValue);
                }
                refetchCurrentUser();

            }
            resetForm()
        } catch (error) {
            handleClose(false, true);

            console.error("Failed to update information:", error);
            toast({
                variant: "error",
                title: "error.failedToUpdate",
                description: error.message,
                duration: 2500,
            });
        }
        setInputValue("");
        setSecondaryInputValue && setSecondaryInputValue("");
    };

    const resetForm = () => {
        setAddressLine1();
        setAddressLine2();
        setZipCode();
        setCity();
        setCountry();
        setIsWrongFormat(false);
    }

    // Ajout d'une fonction pour vider la date de sortie
    const handleClearLeaveDate = async () => {
        try {
            // Si consultantUuid est défini, on utilise la mutation updateLeaveDate
            await updateLeaveDate({ variables: { uuid: consultantUuid, leaveDate: "" } });
            setInformationData && setInformationData((prevData) => ({
                ...prevData,
                leaveDate: null
            }));
            // Mise à jour du context
            setActiveUser({
                ...activeUser,
                leaveDate: inputValue
            });
        } catch (error) {
            console.error("Failed to clear leave date:", error);
        }
        // if (consultantUuid) {
        //     await updateLeaveDate({ variables: { uuid: consultantUuid, leaveDate: "" } });
        //     setInformationData && setInformationData((prevData) => ({
        //         ...prevData,
        //         leaveDate: null
        //     }));
        //     // Mise à jour du context
        //     setActiveUser({
        //         ...activeUser,
        //         leaveDate: inputValue
        //     });
        // }
        setInputValue("");
        setSecondaryInputValue && setSecondaryInputValue("");
        handleClose(false, true, "");
    };
    console.log("data =", data, "exceptionnalData =", exceptionnalData)
    return (
        <Dialog open={open} onOpenChange={handleDialogOpenChange}>
            <DialogTrigger className="invisible group-hover:visible">
                <EditRoundedIcon color='secondary' />
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle><Label message={title} size="h4" /></DialogTitle>
                    <DialogDescription className="flex flex-col gap-4 py-4">
                        <span>
                            <Label message={actualLabel} />
                            {type === "commissionAmounts" ? (
                                <div className="flex items-center gap-firstDegree">
                                    {(data !== undefined && data !== null) ? (
                                        <Label fontWeight="bold">{data} {unit}</Label>
                                    ) : (
                                        <Label color="gray400" message="error.unfilled" />
                                    )}
                                    <Label>/</Label>
                                    {(secondaryData !== undefined && secondaryData !== null) ? (
                                        <Label fontWeight="bold">{secondaryData} {unit}</Label>
                                    ) : (
                                        <Label color="gray400" message="error.unfilled" />
                                    )}
                                </div>
                            ) : (
                                data ? <Label fontWeight="bold">{data} {unit}</Label> : <Label color="gray400" message="error.unfilled" />
                            )}
                        </span>
                        <Label message={selectLabel} />
                        {component && component}
                        {/* Champs particuliers avec switch/case */}
                        {(() => {
                            switch (type) {
                                case "commissionAmounts":
                                    return (
                                        <div className="flex flex-col gap-secondDegree">
                                            <div className="flex items-center gap-2">
                                                <Switch
                                                    checked={autoCommission}
                                                    onCheckedChange={setAutoCommission}
                                                />
                                                <Label message="consultants.statement.billsDetails.autoCommission" />
                                            </div>
                                            {!autoCommission && (
                                                <div className="flex flex-col gap-secondDegree">
                                                    <div className="flex flex-col gap-1">
                                                        <Label size="small" fontWeight="semibold" message="consultants.informations.commissionAmountDefault" />
                                                        <Input
                                                            type={typeForInput}
                                                            value={inputValue || ""}
                                                            onChange={e => setInputValue(e.target.value)}
                                                            placeholder={t("consultants.informations.commissionAmountDefault")}
                                                            onBlur={() => validateInput()}
                                                        />
                                                    </div>
                                                    <div className="flex flex-col gap-1">
                                                        <Label size="small" fontWeight="semibold" message="consultants.informations.dailyCommissionAmount" />
                                                        <Input
                                                            type={typeForInput}
                                                            value={secondaryInputValue || ""}
                                                            onChange={e => setSecondaryInputValue && setSecondaryInputValue(e.target.value)}
                                                            placeholder={t("consultants.informations.dailyCommissionAmount")}
                                                            onBlur={() => validateInput()}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="flex flex-col gap-1">
                                                <Label message="consultants.informations.howAutoCommissionWorkAuto" fontWeight="semibold" />
                                                <Label message="consultants.informations.howAutoCommissionWorkManual" fontWeight="semibold" />
                                            </div>
                                        </div>
                                    );
                                case "commissionAmount":
                                    return (
                                        <div className="flex flex-col gap-secondDegree">
                                            <div className="flex items-center gap-2">
                                                <Switch
                                                    checked={autoCommission}
                                                    onCheckedChange={setAutoCommission}
                                                />
                                                <Label message="consultants.statement.billsDetails.autoCommission" />
                                            </div>
                                            {!autoCommission && <Input
                                                type={typeForInput}
                                                value={!autoCommission ? inputValue : ""}
                                                onChange={e => setInputValue(e.target.value)}
                                                disabled={autoCommission}
                                                placeholder="Montant de la commission"
                                                onBlur={() => validateInput()}
                                                className="disabled:bg-grey"
                                            />}
                                            <div className="flex flex-col gap-1">
                                                <Label message="consultants.informations.howAutoCommissionWorkAuto" className="PrimaryStrong" fontWeight="semibold" />
                                                <Label message="consultants.informations.howAutoCommissionWorkManual" className="PrimaryStrong" fontWeight="semibold" />
                                            </div>

                                        </div>
                                    );
                                case "address":
                                    return (
                                        <>
                                            <Input value={addressLine1} onChange={(e) => { setAddressLine1(e.target.value); isWrongFormat && validateInput(e.target.value) }} placeholder={t("consultants.informations.adress1")} />
                                            <Input value={addressLine2} onChange={(e) => { setAddressLine2(e.target.value); isWrongFormat && validateInput(e.target.value) }} placeholder={t("consultants.informations.adress2")} />
                                            <Input value={zipCode} onChange={(e) => { setZipCode(e.target.value); isWrongFormat && validateInput(e.target.value) }} placeholder={t("consultants.informations.zipCode")} />
                                            <Input value={city} onChange={(e) => { setCity(e.target.value); isWrongFormat && validateInput(e.target.value) }} placeholder={t("consultants.informations.city")} />
                                            <Select onValueChange={(value) => { setCountry(value) }}>
                                                <SelectTrigger className="text-body border-0 bg-lighter py-1">
                                                    <SelectValue
                                                        placeholder={<Label message="consultants.informations.country" />}
                                                    />
                                                </SelectTrigger>
                                                <SelectContent className="h-48">
                                                    {countriesWithPriority && Object.keys(countriesWithPriority).map((countryCode) => (
                                                        <SelectItem key={countryCode} value={countryCode} className="text-body ">
                                                            <Label>{countriesWithPriority[countryCode].name}</Label>
                                                        </SelectItem>
                                                    ))}
                                                </SelectContent>
                                            </Select>
                                        </>
                                    );
                                case "leaveDate":
                                    return (
                                        <Input
                                            type="date"
                                            value={inputValue || ""}
                                            onChange={e => setInputValue(e.target.value)}
                                            placeholder={t("consultants.informations.leaveDate")}
                                            onBlur={() => validateInput()}
                                        />
                                    );
                                case "consultantProfile":
                                    return (
                                        <>
                                            {profilesLoading && <span className="loader" />}
                                            {profilesError && <PrintErrorMessage error={profilesError} />}
                                            {(!profilesError && !profilesLoading && allProfiles) && (
                                                <Select value={inputValue} onValueChange={setInputValue}>
                                                    <SelectTrigger className="w-full">
                                                        <SelectValue placeholder={data} />
                                                    </SelectTrigger>
                                                    <SelectContent>
                                                        {allProfiles.map((profile) => (
                                                            <SelectItem key={profile.uuid} value={profile.uuid}>
                                                                {profile.name}
                                                            </SelectItem>
                                                        ))}
                                                    </SelectContent>
                                                </Select>
                                            )}
                                        </>
                                    );
                                default:
                                    return (
                                        <Input type={typeForInput} value={inputValue} onChange={(e) => { isWrongFormat && validateInput(e.target.value); setInputValue(e.target.value) }} onBlur={() => validateInput()} />
                                    );
                            }
                        })()}
                        {isWrongFormat && <Label className="text-error" message="error.wrongFormat" />}
                        {errorRetribution && <PrintErrorMessage error={errorRetribution} />}
                        {errorLanguage && <PrintErrorMessage error={errorLanguage} />}
                        {errorIban && <PrintErrorMessage error={errorIban} />}
                        {errorBic && <PrintErrorMessage error={errorBic} />}
                        {errorPhoneNumber && <PrintErrorMessage error={errorPhoneNumber} />}
                        {errorPersonalEmail && <PrintErrorMessage error={errorPersonalEmail} />}
                        {errorAddress && <PrintErrorMessage error={errorAddress} />}
                        {errorFiduciaryId && <PrintErrorMessage error={errorFiduciaryId} />}
                        {errorLeaveDate && <PrintErrorMessage error={errorLeaveDate} />}
                        {errorProfile && <PrintErrorMessage error={errorProfile} />}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="sm:justify-start">
                    <Button type="button" style="ghost" text='global.actions.cancel' onClick={() => { setInputValue(""); setSecondaryInputValue && setSecondaryInputValue(""); handleClose(false, false, inputValue) }} />

                    <div className=" flex justify-center items-center">
                        {loadingRetribution && <span className="loader" />}
                        {loadingLanguage && <span className="loader" />}
                        {loadingIban && <span className="loader" />}
                        {loadingBic && <span className="loader" />}
                        {loadingPhoneNumber && <span className="loader" />}
                        {loadingPersonalEmail && <span className="loader" />}
                        {loadingAddress && <span className="loader" />}
                        {loadingFiduciaryId && <span className="loader" />}
                        {loadingLeaveDate && <span className="loader" />}
                        {loadingProfile && <span className="loader" />}
                    </div>
                    {/* Cas particulier pour leaveDate : bouton outline pour annuler */}
                    {type === "leaveDate" && (
                        <Button
                            style="outline"
                            text='global.actions.cancelLeaveDate'
                            className="w-full"
                            onClick={handleClearLeaveDate}
                        />
                    )}
                    <Button
                        style="fill"
                        text='global.actions.save'
                        className="w-full"
                        onClick={handleSave}
                        disabled={
                            (type !== 'address' && type !== 'commissionAmount' && type !== 'commissionAmounts' && type !== 'leaveDate' && !inputValue) ||
                            (type === 'commissionAmount' && !autoCommission && !inputValue) ||
                            (type === 'commissionAmounts' && ((!autoCommission && !inputValue) || !secondaryInputValue)) ||
                            (type === 'leaveDate' && isWrongFormat) ||
                            isWrongFormat ||
                            loadingRetribution ||
                            loadingLanguage ||
                            loadingIban ||
                            loadingBic ||
                            loadingPhoneNumber ||
                            loadingPersonalEmail ||
                            loadingAddress ||
                            loadingFiduciaryId ||
                            loadingLeaveDate ||
                            loadingProfile
                        }
                    />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
